import { Typography, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";

// TODO: Use theme
export const BodyText = styled(Typography)(() => ({
  color: ediphiPalette.textMuted,

  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
}));
